import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import config from "../../config";
import { Row, Col, Card, Breadcrumb, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import GifLoder from '../../components/GifLoder';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom"; // Import useNavigate
import CustomConfirmPopup from "../../components/CustomConfirmPopup";
import { GiCheckMark } from "react-icons/gi";

const Client_form_list = () => {
    const { accessToken } = useAuth();
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [forms, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({});
    const [currentStep, setCurrentStep] = useState(0);
    const [duplicatedSections, setDuplicatedSections] = useState({});
    const navigate = useNavigate();



    useEffect(() => {
        fetchCategories();
    }, [accessToken]);

    // Fetch Categories
    const fetchCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/get-form-categories`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            const categoriesData = response.data.data;
            setCategories(categoriesData);
            setSelectedCategory(categoriesData[0].type);
            // Automatically fetch forms for the first category type if available
            if (categoriesData.length > 0) {
                fetchForms(categoriesData[0].type);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };


    // Fetch Forms by Category
    const fetchForms = async (categoryType) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/fetch-forms?type=${categoryType}`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            setForms(response.data);

            // Automatically select the first form if available
            if (response.data.length > 0) {
                setSelectedForm(response.data[0]);
            } else {
                setSelectedForm(null);
            }
        } catch (err) {
            setError("Failed to fetch forms");
            console.error("Error fetching forms:", err);
            setSelectedForm(null);
        } finally {
            setLoading(false);
        }
    };



    const handleChange = (sectionId, fieldId, value) => {
        setFormData((prev) => ({
            ...prev,
            [sectionId]: {
                ...prev[sectionId],
                [fieldId]: value,
            },
        }));
    };






    const nextStep = () => {
        setCurrentStep((prev) => Math.min(prev + 1, selectedForm.sections.length - 1));
    };

    const prevStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    const duplicateSection = (section) => {
        setDuplicatedSections((prev) => {
            const sectionId = section.form_section_id;

            // Deep copy the section and its fields
            const newDuplicate = {
                id: Date.now(),
                ...section,
                fields: section.fields.map(field => ({ ...field, id: Date.now() })) // Copy each field uniquely
            };

            return {
                ...prev,
                [sectionId]: [...(prev[sectionId] || []), newDuplicate],
            };
        });
    };


    const removeDuplicatedSection = (sectionId, duplicateId) => {
        setDuplicatedSections((prev) => ({
            ...prev,
            [sectionId]: prev[sectionId].filter((dup) => dup.id !== duplicateId),
        }));
    };


    // Function to delete the form
    const handleDeleteForm = async (formId) => {
        setLoading(true);
        try {
            await axios.delete(`${config.apiBASEURL}/ClientFormRoutes/delete-Client-form/${formId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`, // Pass token for authentication
                },
            });

            fetchCategories();// Refresh the list after deletion
        } catch (error) {
            console.error("Error deleting form:", error);
        }
        finally {
            setLoading(false);
        }
    };


    /*-------------------Steep_count------------------*/

    const totalSteps = selectedForm?.sections
        ? Object.keys(
            selectedForm.sections.reduce((acc, section) => {
                acc[section.step] = acc[section.step] || [];
                acc[section.step].push(section);
                return acc;
            }, {})
        ).length
        : 0;


    const progressPercentage = ((currentStep + 1) / totalSteps) * 100;


    return (
        <>
            {loading ? (
                <div className="loderDiv">
                    <GifLoder />
                </div>
            ) : (
                <Row className='body_content'>
                    <Row className='mx-0'>
                        <Col md={12} lg={12} className='mb-4 d-flex justify-content-between align-items-center'>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Client Form Preview</Breadcrumb.Item>
                            </Breadcrumb>
                            <Link to="/Graphe/dashboard/dynamic_Form">
                                <Button
                                    label="Create Form"
                                    icon="pi pi-plus"
                                    className="py-2 px-2 px-lg-3"
                                    severity="help"
                                />
                            </Link>
                        </Col>

                        <Col lg={12} className="px-0">

                            {/* Display Categories */}
                            <div className="d-flex flex-wrap gap-1 mb-5">
                                {categories.map((category) => (
                                    <Button
                                        key={category.form_categories_id}
                                        className={`py-2 mx-1 border-0 rounded ${selectedCategory === category.type
                                            ? "bg-secondary-500 text-white"
                                            : "bg-secondary text-white shadow-sm"
                                            }`}
                                        onClick={() => {
                                            setSelectedCategory(category.type);
                                            fetchForms(category.type);
                                            setSelectedForm(null); // Reset selected form
                                            setCurrentStep(0);
                                        }}
                                    >
                                        {category.category_name}
                                    </Button>
                                ))}
                            </div>

                            {/* Display Forms */}
                            {loading && <p>Loading...</p>}
                            {error && <p className="text-red-500">{error}</p>}

                            <Row className="mx-0">
                                <Col lg={3} className="pe-0 ps-0 pe-lg-3">
                                    <Card className="sticky-top h-auto shadow-0 bg-transparent">
                                        {forms.length > 0 ? (
                                            forms.map((form) => (
                                                <div
                                                    key={form.form_id}
                                                    className={`rounded-lg shadow-sm ps-4 py-3 pe-2 mb-3 position-relative
        ${selectedForm?.form_id === form.form_id ? "text-white activebgcolor" : "bg-white text-dark inactivebgcolor"}`}
                                                    onClick={() => {
                                                        setSelectedForm(form);
                                                        setCurrentStep(0);
                                                    }}

                                                    style={{ cursor: 'pointer' }}
                                                >

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className="mb-0 text-black">{form.form_name}</h6>
                                                            <p className="mb-0 mt-2">
                                                                <small className="text-secondary  mb-0 d-block" style={{ fontWeight: '400' }}>
                                                                    {form.description}
                                                                </small>
                                                            </p>
                                                        </div>
                                                        <div style={{ position: 'absolute', right: '5px', top: '5px' }}>
                                                            <Button
                                                                title="Edit"
                                                                icon="pi pi-pencil"
                                                                className="iconEdit_btn p-0"
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // Prevent div click from triggering selection
                                                                    navigate(`/Graphe/dashboard/edit_dynamic_Form/${form.form_id}`);
                                                                }}
                                                                text
                                                                severity="info"
                                                            />

                                                            <CustomConfirmPopup
                                                                message="Are you sure you want to delete this form?"
                                                                icon="pi pi-exclamation-triangle"
                                                                defaultFocus="accept"
                                                                acceptClassName="p-button-danger"
                                                                buttonLabel="Delete"
                                                                title="Delete Form"
                                                                buttonClass="p-button-danger p-button-text"
                                                                className="border-0 p-0"
                                                                buttonIcon="pi pi-trash"
                                                                onConfirm={() => handleDeleteForm(form.form_id)}
                                                                onReject={() => console.log("Delete action canceled")}
                                                            />

                                                        </div>

                                                    </div>

                                                </div>
                                            ))
                                        ) : (
                                            <p className="p-4">No forms available for this category.</p>
                                        )}
                                    </Card>
                                </Col>
                                <Col lg={9} className="ps-0 ps-lg-3">
                                    {selectedForm ? (
                                        <Card className="mt-6 shadow-0 border">
                                            <Card.Header className="sticky-top  bg-white" style={{ top: '-35px' }}>
                                                <div>
                                                    <h6 className="mb-0">{selectedForm.form_name}</h6>
                                                    <p className="mb-0 text-muted"><small>{selectedForm.description}</small></p>
                                                </div>
                                                <div className="d-flex justify-content-left pt-4 pb-5 w-100">
                                                    <div className="w-100 position-relative">
                                                        <ProgressBar now={progressPercentage} variant="success" />
                                                        <div className="d-flex justify-content-between position-absolute w-100" style={{ top: "-10px" }}>
                                                            {Array.from({ length: totalSteps }, (_, index) => (
                                                                <div key={index} className="position-relative text-center">
                                                                    <div
                                                                        className={`rounded-circle d-flex align-items-center justify-content-center 
                                    ${index <= currentStep ? "bg-success text-white" : "bg-light border"}
                                `}
                                                                        style={{ width: "24px", height: "24px" }}
                                                                    >
                                                                        {index <= currentStep && <GiCheckMark size={16} />}
                                                                    </div>
                                                                    <div className="mt-2" style={{ fontSize: "14px" }}>Step {index + 1}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                {/* Group sections by step */}
                                                {Object.entries(
                                                    selectedForm.sections.reduce((acc, section) => {
                                                        acc[section.step] = acc[section.step] || [];
                                                        acc[section.step].push(section);
                                                        return acc;
                                                    }, {})
                                                )
                                                    .sort(([stepA], [stepB]) => stepA - stepB) // Sort steps
                                                    .map(([step, sections], index) =>
                                                        currentStep === index ? (
                                                            <div key={step} >
                                                                {sections.map((section) => (
                                                                    <div key={section.form_section_id} className="mb-4" >
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <h6>{section.section_name}</h6>
                                                                            {section.is_repeatable && (
                                                                                <Button
                                                                                    label="Add"
                                                                                    icon="pi pi-plus"
                                                                                    className="p-0"
                                                                                    text
                                                                                    severity="danger"
                                                                                    onClick={() => duplicateSection(section)}
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        <div className="mt-2 d-flex flex-wrap gap-2 justify-content-between">
                                                                            {section.fields.map((field) => (
                                                                                <div key={field.form_fields_id} className="mt-2 responwidth" style={{ width: '48.5%' }}>
                                                                                    <label className="block font-medium mb-2">{field.field_label}</label>

                                                                                    {field.input_type === "text" && (
                                                                                        <InputText
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                            }
                                                                                            className="w-full p-2"
                                                                                        />
                                                                                    )}

                                                                                    {field.input_type === "number" && (
                                                                                        <InputNumber
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            onValueChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                            }
                                                                                            className="w-full"
                                                                                        />
                                                                                    )}

                                                                                    {field.input_type === "email" && (
                                                                                        <InputText
                                                                                            type="email"
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                            }
                                                                                            className="w-full p-2"
                                                                                        />
                                                                                    )}

                                                                                    {field.input_type === "date" && (
                                                                                        <Calendar
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                            }
                                                                                            className="w-full"
                                                                                        />
                                                                                    )}

                                                                                    {field.input_type === "textarea" && (
                                                                                        <InputTextarea
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                            }
                                                                                            rows={4}
                                                                                            className="w-full p-2"
                                                                                        />
                                                                                    )}

                                                                                    {field.input_type === "select" && field.options && (
                                                                                        <Dropdown
                                                                                            value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                            options={field.options.split(",").map((option) => ({
                                                                                                label: option.trim(),
                                                                                                value: option.trim(),
                                                                                            }))}
                                                                                            onChange={(e) =>
                                                                                                handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                            }
                                                                                            placeholder="Select an option"
                                                                                            className="w-full"
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            ))}
                                                                        </div>

                                                                        {/* Display Duplicated Sections */}
                                                                        {section.is_repeatable && duplicatedSections[section.form_section_id]?.length > 0 &&
                                                                            duplicatedSections[section.form_section_id].map((dup, i) => (
                                                                                <div key={dup.id} className="mt-3 oddSteplist">
                                                                                    <div className="d-flex justify-content-between align-items-center pb-2 mb-3">
                                                                                        <h6>{section.section_name} {i + 2}</h6>
                                                                                        <Button
                                                                                            title="Remove"
                                                                                            icon="pi pi-trash"
                                                                                            className="p-0"
                                                                                            text
                                                                                            severity="danger"
                                                                                            onClick={() => removeDuplicatedSection(section.form_section_id, dup.id)}
                                                                                        />
                                                                                    </div>

                                                                                    {dup.fields.map((field) => (
                                                                                        <div key={field.id} className="mt-2">
                                                                                            <label className="d-block mb-2">{field.field_label}</label>
                                                                                            {field.input_type === "text" && (
                                                                                                <InputText value={field.value} disabled className="w-full p-2 bg-gray-200" />
                                                                                            )}
                                                                                            {field.input_type === "number" && (
                                                                                                <InputNumber value={field.value} disabled className="w-full bg-gray-200" />
                                                                                            )}
                                                                                            {field.input_type === "email" && (
                                                                                                <InputText type="email" value={field.value} disabled className="w-full p-2 bg-gray-200" />
                                                                                            )}
                                                                                            {field.input_type === "date" && (
                                                                                                <Calendar value={field.value} disabled className="w-full bg-gray-200" />
                                                                                            )}
                                                                                            {field.input_type === "textarea" && (
                                                                                                <InputTextarea value={field.value} disabled rows={4} className="w-full p-2 bg-gray-200" />
                                                                                            )}
                                                                                            {field.input_type === "select" && field.options && (
                                                                                                <Dropdown value={field.value} options={field.options} disabled className="w-full bg-gray-200" />
                                                                                            )}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : null
                                                    )}
                                            </Card.Body>

                                            <Card.Footer className="d-flex justify-content-end align-items-center px-2">
                                                <Button
                                                    label="Back"
                                                    icon="pi pi-arrow-left"
                                                    className="py-2"
                                                    disabled={currentStep === 0}
                                                    onClick={prevStep}
                                                    severity="primary"
                                                />
                                                {currentStep === Object.keys(
                                                    selectedForm.sections.reduce((acc, section) => {
                                                        acc[section.step] = acc[section.step] || [];
                                                        acc[section.step].push(section);
                                                        return acc;
                                                    }, {})
                                                ).length - 1 ? (
                                                    <Button
                                                        label="Submit"
                                                        icon="pi pi-check"
                                                        className="py-2 ms-2"
                                                        severity="success"
                                                    />
                                                ) : (
                                                    <Button
                                                        label="Next"
                                                        icon="pi pi-arrow-right"
                                                        className="ms-2 py-2"
                                                        onClick={nextStep}
                                                        severity="primary"
                                                        iconPos="right"
                                                    />
                                                )}
                                            </Card.Footer>
                                        </Card>
                                    ) : (
                                        <Card className=" shadow-0">
                                            <Card.Body>
                                                <p className="p-1 mb-0 text-center">No form selected.</p>
                                            </Card.Body>
                                        </Card>
                                    )}
                                </Col>

                            </Row>


                            {/* Display Multi-step Form */}

                        </Col>
                    </Row >
                </Row >
            )}
        </>
    );
};

export default Client_form_list;
